import React, { createContext, useContext, ReactNode } from 'react';
import { useLanguage, Language } from '../hooks/useLanguage';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  translate: (data: any, key?: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const { language, setLanguage, translate } = useLanguage();

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguageContext must be used within a LanguageProvider');
  }
  return context;
};